import Prismic from 'prismic-javascript';

// In src/prismic-configuration.js
export const linkResolver = (doc) => {
  // URL for a category type
  if (doc.type === 'workshop') {
    return `/workshop/${doc.uid}`;
  }
  // Backup for all other types
  return '/';
};

const apiEndpoint = 'https://we3academy.cdn.prismic.io/api/v2';
const accessToken =
  'MC5YMGRoOHhJQUFBX05nTGV2.77-9GO-_vStkYjZv77-977-977-9S--_vVTvv70beu-_ve-_vUDvv70I77-9Su-_vRxz77-977-9Glnvv70'; // This is where you would add your access token for a Private repository

export const Client = Prismic.client(apiEndpoint, { accessToken });
